import { Button } from "antd";
import { getDayId } from ".";
import Icon, { ICON_NAME } from "../../../components/Icon";
import { getCalendar } from "../../../contexts/CalendarContext";
import { datetime } from "../../../util/library/datetime";
import { aDayMillisecond, VIEW_SMOOTH } from "../../../util/varibles/constants";
import { getElById } from "../../../util/varibles/global";
import WeekControl from "../_components/WeekControl";
import { CALENDAR_ID } from "../constants";
import styles from "./style.module.scss";

const HeaderCalendarSite: React.FC = () => {
    const get = getCalendar();
    const onPush = (value: number) => {
        const calendar = document.getElementById(CALENDAR_ID);
        if (calendar) {
            const { startTime, widthDay } = get();
            const { scrollLeft } = calendar;
            const day = Math.round(Math.max(scrollLeft, 160 + widthDay) / widthDay);
            const time = datetime(startTime + (day * aDayMillisecond)).add(value, "week").startOf("week").time;
            const el = getElById(getDayId(time));
            if (el) {
                const { offsetLeft } = el;
                calendar.scroll({ left: offsetLeft, ...VIEW_SMOOTH })
            }
        }
    }

    const onToday = () => {
        const time = datetime().startOf('day').time;
        const element = document.getElementById(getDayId(time));
        if (element) {
            const { offsetLeft } = element;
            const calendar = document.getElementById(CALENDAR_ID);
            if (calendar) {
                calendar.scroll({ left: offsetLeft, ...VIEW_SMOOTH });
            }
        }
    }

    return <div className="flex justify-between items-center h-[60px]">
        <div className="flex gap-2 ml-[80px] items-center">
            <Button
                className='bt-default h-32'
                onClick={onToday}
            >
                Today
            </Button>
            <div className={styles.prev} onClick={() => onPush(-1)}>
                <Icon icon={ICON_NAME.ARROW_2} />
            </div>
            <div className={styles.next} onClick={() => onPush(1)}>
                <Icon icon={ICON_NAME.ARROW_2} />
            </div>
        </div>
        <WeekControl />
        <div className="w-[100px]" />
    </div>
}

export default HeaderCalendarSite;